import { render, staticRenderFns } from "./CbsCardActions.vue?vue&type=template&id=21d053be&scoped=true"
import script from "./CbsCardActions.vue?vue&type=script&lang=js"
export * from "./CbsCardActions.vue?vue&type=script&lang=js"
import style0 from "./CbsCardActions.vue?vue&type=style&index=0&id=21d053be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d053be",
  null
  
)

export default component.exports